import { Instagram, Facebook, MessageCircle, Mail } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

const QUICK = [
  { id: "inicio",      label: "Inicio" },
  { id: "productos",   label: "Productos" },
  { id: "proceso",     label: "Proceso" },
  { id: "galeria",     label: "Galería" },
  { id: "testimonios", label: "Testimonios" },
  { id: "contacto",    label: "Contacto" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-persia-black text-white/70">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
          <div className="mb-6">
  <img
    src="/images/logo persia.png"
    alt="Persia Persianas y Cortinas"
    className="h-20 w-auto"
  />
</div>
            <p className="text-sm font-light leading-relaxed max-w-md">
              Persianas y cortinas a la medida en Guadalajara y Zona Metropolitana.
              Diseños modernos, elegantes y funcionales para transformar tus espacios
              con estilo, confort y privacidad.
            </p>

            <div className="flex items-center gap-3 mt-7">
              <a href={SITE.social.instagram} target="_blank" rel="noreferrer"
                 className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-persia-black transition-all">
                <Instagram size={16} />
              </a>
              <a href={SITE.social.facebook} target="_blank" rel="noreferrer"
                 className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-persia-black transition-all">
                <Facebook size={16} />
              </a>
              <a href={waLink("Hola, vengo del sitio web.")} target="_blank" rel="noreferrer"
                 className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-persia-black transition-all">
                <MessageCircle size={16} />
              </a>
              <a href={`mailto:${SITE.email}`}
                 className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-persia-black transition-all">
                <Mail size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-display text-[11px] tracking-[0.3em] uppercase text-gold mb-5">Navegación</div>
            <ul className="space-y-3">
              {QUICK.map((q) => (
                <li key={q.id}>
                  <a href={`#${q.id}`} className="text-sm font-light hover:text-gold transition-colors">
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-display text-[11px] tracking-[0.3em] uppercase text-gold mb-5">Contacto</div>
            <ul className="space-y-5 text-sm">
              <li>
                <a href={waLink("Hola, vengo del sitio.")} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors flex items-center gap-3">
                  <MessageCircle size={15} className="text-gold" /> <span className="font-bold text-white text-lg">
  {SITE.phoneDisplay}
</span>
                </a>
              </li>
              <li>
                <a href={`mailto:$<span className="font-semibold text-white">
  {SITE.email}
</span>`} className="hover:text-gold transition-colors flex items-center gap-3">
                  <Mail size={15} className="text-gold" /> {SITE.email}
                </a>
              </li>
              <li className="text-white/60">
                Zona de servicio: <span className="text-white">{SITE.zone}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-light text-white/50">
            © 2026 {SITE.brand}. Todos los derechos reservados.
          </p>
          <p className="text-xs font-light text-white/40 font-display tracking-[0.2em] uppercase">
            Diseño · Confort · Privacidad
          </p>
        </div>
      </div>
    </footer>
  );
}
